import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 1,
    title: "Enterprise Cloud Hosted LLM + RAG Platform",
    description: "Architected and deployed a production LLM platform serving 100K+ daily queries with sub-second latency. Implemented RAG pipelines with configurable parameters (optimized by Data Scientists) and a HNSW PGVector Implementation on Aurora Postgres",
    image: "/images/llm-platform.png",
    tags: ["Python", "LangChain", "LangGraph", "PyTorch", "AWS ECS", "AWS Aurora Postgres w/ PGVector"],
    githubUrl: "https://github.com/sohailm25",
    liveUrl: ""
  },
  {
    id: 2,
    title: "Multi-Agent Research System",
    description: "Built a personal autonomous multi-agent system for complex research tasks, featuring agent orchestration, tool integration, and collaborative reasoning. Reduced research time by 70% through intelligent task decomposition.",
    image: "/images/multi-agent-system.png",
    tags: ["LangChain", "OpenAI", "FastAPI", "Redis", "Docker"],
    githubUrl: "https://github.com/sohailm25",
    liveUrl: ""
  },
  {
    id: 3,
    title: "MLOps Pipeline Architecture for Data Science Team on Edge AI Implementation",
    description: "Researched and developed an iterable CI/CD Pipeline bridging Data Scientists and Engineers on Wendy's FreshAI initiative; serving thousands of customers daily within the AI Drive-Thru, allowing for seamless prompt refinement and hyperparameter tuning with sub-second A/B Testing",
    image: "/images/mlops-pipeline.png",
    tags: ["Databricks", "GCP Vertex AI", "GCP Dataproc", "MLFlow", "Snowflake", "Python"],
    githubUrl: "https://github.com/sohailm25",
    liveUrl: ""
  }
];
